//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.MultipleObjectsBuilder.js";
import "../AME/AME.SelectClassificationBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BreakUnLockedTemplate",1,0],[0,"ClearTiaTypeIdentifierInType",1,0],[0,"ExchangePLCRelevantProduct",1,0],[0,"ExchangeProductForNotLockedTemplate",1,0],[0,"PlaceInProductAspect",1,0],[0,"ProductType",1,0],[0,"RemovePLCRelevantProduct",1,0],[1,"SelectClassification",0,"AME.SelectClassificationBuilder",0],[1,"SelectedDevices",0,"SelectNXObjectList",0]],[[["selectedProduct"],"SetSelectedProduct",{},1,0],[["auxiliaryProducts"],"SetAuxiliaryProducts",{},1,0],[["plcHwItem"],"RemoveTiaLibraryReference",{},1,1],[["engObject"],"RemoveTiaLibraryReferenceFromEngObject",{},1,0]],[]];
SPLM.AME.ProductSelectionBuilder = class extends SPLM.AME.MultipleObjectsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ProductSelectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ProductSelectionBuilder.Type = Object.freeze({
    "SameEngineeringObjectDefinition" : "SameEngineeringObjectDefinition", "SameClassificationAndMoreDetailedClassification" : "SameClassificationAndMoreDetailedClassification", "AllCommonProducts" : "AllCommonProducts"});

export default SPLM;